<div class="layout-shop">

  <!-- Sidebar and Main Content Wrapper -->
  <div class="layout-shop__content-wrapper">
    <!-- Sidebar -->
    <!-- @if(!isMobile()) { -->
    <div class="layout-shop__sidebar height-sidebar-global-message" [class.sidebar--closed]="false"
      [class.d-none]="isInSearchMode()">
      <div class="overlay" (click)="toggleSidebar()"></div>
      <app-sidebar (outIsMenuReady)="scrollIntoView()"></app-sidebar>
    </div>
    <!-- } -->

    <!-- Main content -->
    <div class="layout-shop__main" #layoutShopMain (scroll)="onScroll($event)" id="layoutShopMain">

    @if (isInSearchMode()) {
    <!-- Desktop-only: below lg the header renders its own results banner in the sub-nav strip. -->
    <div
      class="search-mode-banner animated fadeIn px-3 py-2 d-none d-lg-flex align-items-center gap-2 border-bottom bg-white position-sticky top-0 z-3">
      <span class="text-muted small">
        <strong>{{ searchResultCount() }}</strong> results for "<strong>{{ signalsStore.searchModeQuery() }}</strong>"
      </span>
      <button type="button" class="btn btn-sm btn-outline-secondary ms-auto" (click)="exitSearchMode()">
        <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">close</span>
        Clear search
      </button>
    </div>
    }

    @if(!marketStatus().isOpen) {
    <div class="closed-market-container animated fadeIn">
      <div class="alert" role="alert">
        <span class="material-symbols-outlined mat-icon-fill icon">
          calendar_today
        </span>
        <div class="text-container">

          <p class="header">{{closedMarket().title}}</p>
          <p class="legend">{{closedMarket().legend}}</p>
        </div>
      </div>
    </div>
    }

    <!-- Visibility is left to CSS (Bootstrap lg = 992px) instead of !isMobile(), because
         ResolutionService.isMobile() is innerWidth <= LARGE (1200px). With the TS guard, the
         992-1200px band rendered nothing at all on /shop: this mount was suppressed by
         !isMobile(), while the header's mobile overlay mounted but was hidden by its own
         d-lg-none. Below lg the header overlay owns the search UI. -->
    @if(isShowingShopFilters()) {
    <div class="shop-filters d-none d-lg-block" [class.mb-3]="isFilteringByTags()">
      <app-search-bar></app-search-bar>
    </div>
    }

    @if (isContentLoading()) {
    <div class="px-3">
      <mat-progress-bar class="rounded layout-shop__progress-bar" mode="indeterminate"
        value="accent"></mat-progress-bar>
    </div>
    }

    <div class="container-fluid">

      @if (isFilteringByTags() && isMobile()) {
      <div class="shop-tags-filter">
        <app-filtering-tags></app-filtering-tags>
        <hr class="animated fadeIn">
      </div>
      }

      @if (filters().size) {
      <ul class="filter-chips-container" [class.filtering-by-tags]="isFilteringByTags() && isMobile()">
        @for (filter of filters().entries(); track trackByFilterKey($index, filter)) {
        <li>
          <mat-chip-row (removed)="removeChipFilter(filter[0])" [editable]="true" class="bg-secondary bg-opacity-25">
            <div class="d-flex gap-1">
              <b>{{filter[1].type}}:</b> <span class="fst-italic text-decoration-underline">{{filter[1].value}}</span>
            </div>
            <button matChipRemove [attr.aria-label]="'remove ' + filter[0]">
              <span class="material-symbols-outlined">
                close
              </span>
            </button>
          </mat-chip-row>
        </li>
        }
      </ul>
      }

      @if (isFilteringByTags() && !isMobile()) {
      <div class="shop-tags-filter" [class.filtering-by-searchbar]="filters().size > 0">
        <app-filtering-tags></app-filtering-tags>
        <hr class="animated fadeIn">
      </div>
      }

      @if (!isContentLoading() && isContentLoaded()) {
      @if (!productsSignal().length) {
      <app-empty-message [message]="emptyMessage" class="mt-4"></app-empty-message>
      }
      }

      <div class="row product-card-grid" id="scroll-to-top-ref"
        [class.padding-at-bottom-sm]="productsSignal().length <= 3">
        <!-- @defer (on viewport) { -->
        @if (productsSignal()) {

        @for (product of productsSignal(); track product.id + '-' + $index) {

        @if (product.categoryInView?.show) {
        @if (product.categoryInView?.banner) {

        @let categoryUrl = product.categoryInView?.url;
        @if (categoryUrl) {
        <a [href]="categoryUrl" [attr.category-id]="product.category.id" [id]="product.category.id"
          [attr.shop-data-anchor-link]="product.categoryAnchorLink">
          <img [src]="product.categoryInView?.banner" alt="Banner of category {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4 shop-banner-img" >
        </a>
        } @else {
        <div [attr.category-id]="product.category.id" [id]="product.category.id"
          [attr.shop-data-anchor-link]="product.categoryAnchorLink">
          <img [src]="product.categoryInView?.banner" alt="Banner of category {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4 shop-banner-img" >
        </div>
        }

        } @else {
        <h2 class="category-name mb-2 mb-sm-4" [attr.category-id]="product.category.id"
          [attr.sub-category-id]="product.subcategory.id" [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id" [attr.shop-data-anchor-link]="product.categoryAnchorLink" #category>
          {{ product.category.name }}
        </h2>
        }
        }

        @if (product.subCategoryInView?.show) {
        @if (product.subCategoryInView?.banner) {

        @let subCategoryUrl = product.subCategoryInView?.url;
        @if (subCategoryUrl) {
        <a [href]="subCategoryUrl" [attr.category-id]="product.category.id"
          [attr.sub-category-id]="product.subcategory.id" [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id"
          [attr.shop-data-anchor-link]="product.subcategoryAnchorLink" #subcategory>
          <img [src]="product.subCategoryInView?.banner" alt="Banner of subcategory {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4 shop-banner-img" >
        </a>
        } @else {
        <div [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id"
          [attr.shop-data-anchor-link]="product.subcategoryAnchorLink" #subcategory>
          <img [src]="product.subCategoryInView?.banner" alt="Banner of subcategory {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4 shop-banner-img" >
        </div>
        }

        } @else {
        <h3 class="subcategory-name mb-2 mb-sm-4" [attr.category-id]="product.category.id"
          [attr.sub-category-id]="product.subcategory.id" [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id"
          [attr.shop-data-anchor-link]="product.subcategoryAnchorLink" #subcategory>
          {{ product.subcategory.name }}
        </h3>
        }
        }

        @if (product.subCategorySonInView?.show) {
        @if (product.subCategorySonInView?.banner) {


        @let subCategorySonUrl = product.subCategorySonInView?.url;
        @if (subCategorySonUrl) {
        <a [href]="subCategorySonUrl" [attr.category-id]="product.category.id"
          [attr.sub-category-id]="product.subcategory.id" [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id"
          [attr.shop-data-anchor-link]="product.subcategorySonAnchorLink" #subcategorySon>
          <img [src]="product.subCategorySonInView?.banner" alt="Banner of subcategory {{product.subcategorySon.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4 shop-banner-img" >
        </a>
        } @else {
        <div [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id"
          [attr.shop-data-anchor-link]="product.subcategorySonAnchorLink" #subcategorySon>
          <img [src]="product.subCategorySonInView?.banner" alt="Banner of subcategory {{product.subcategorySon.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4 shop-banner-img" >
        </div>
        }

        } @else {
        <h4 class="subcategory-son-name mb-2 mb-sm-4" [attr.category-id]="product.category.id"
          [attr.sub-category-id]="product.subcategory.id" [attr.sub-category-son-id]="product.subcategorySon.id"
          [id]="product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id"
          [attr.shop-data-anchor-link]="product.subcategorySonAnchorLink" #subcategorySon>
          {{ product.subcategory.name }}: <span class="text-secondary">{{ product.subcategorySon.name }}</span>
        </h4>
        }
        }


        @defer (on viewport; prefetch on immediate) {
        @if ($index > 11) {
        <div class="col-xxl-3 col-lg-4 col-6 p-0" id="{{product.id}}" (mouseenter)="onProductCardHover(product.id)" ngSkipHydration>
          <div class="product-card-grid__item">
            @let productDetails = this.productDetails().get(product.id);
            <app-product-card-v2 [cardResume]="{ product, settings: {}, productDetails:  productDetails}"
              (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails">
            </app-product-card-v2>
          </div>
        </div>
        } @else {
        <div class="col-xxl-3 col-lg-4 col-6 p-0" id="{{product.id}}" (mouseenter)="onProductCardHover(product.id)">
          <div class="product-card-grid__item">
            @let productDetails = this.productDetails().get(product.id);
            <!-- First 6 products load images eagerly with high priority for LCP optimization -->
            <app-product-card-v2 [cardResume]="{ product, settings: {}, productDetails:  productDetails}"
              (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails"
              [isAboveTheFold]="$index < 6">
            </app-product-card-v2>
          </div>
        </div>
        }
        } @placeholder {
        <div class="col-xxl-3 col-lg-4 col-6 p-0" id="{{product.id}}">
          <div class="product-card-grid__item__placeholder">
          </div>
        </div>
        }

        }
        }

        <!-- }
        @placeholder {
        <div class="px-3">
          <mat-progress-bar class="rounded layout-shop__progress-bar" mode="indeterminate"
            value="accent"></mat-progress-bar>
        </div>
        } -->
      </div>
    </div>
  </div>
  </div>
</div>